<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import Modal from '@/components/Modal.vue'
import logo from '@/assets/figma/chrome-logo.svg'

interface ChromeInfoProps {
 onlyModal?: boolean
}

withDefaults(defineProps<ChromeInfoProps>(), {
  onlyModal: false,
})

const chromeModalRef = ref<InstanceType<typeof Modal>>()

const openModal = () => {
  chromeModalRef.value?.openModal()
}
const closeModal = () => {
  chromeModalRef.value?.closeModal()
}

onMounted(() => {
  openModal()
})
</script>

<template>
  <div class="w-full">
    <button v-if="!onlyModal"
      class="card w-full space-y-2 flex items-center gap-2 py-4 lg:py-[18px] px-4 cursor-pointer"
      @click="openModal"
      type="button"
    >
      <img :src="logo" alt="Logo" class="w-auto h-10 object-contain !mb-0" />
      <span class="text-body-md text-gray-800 text-start">{{ $t('chrome_info.message') }}</span>
    </button>

    <Modal ref="chromeModalRef">
      <div class="card p-4 flex flex-col items-center justify-center max-w-sm mx-auto rounded-4xl">
        <span class="flex items-center justify-center w-10 h-10 bg-gray-100 rounded-full mb-4">
          <MIcon name="error" size="20px" class="text-gray-700" />
        </span>

        <h1 class="text-title-md text-blue-600 text-center">{{ $t('chrome_info.title') }}</h1>
        <p class="text-body-md text-gray-700 text-center mt-2 text-pretty">
          {{ $t('chrome_info.message') }}
        </p>

        <div class="flex flex-col items-center justify-between w-full gap-2 mt-10">
          <a
            href="https://www.google.com/chrome/"
            target="_blank"
            rel="noopener noreferrer"
            class="btn btn-primary"
          >
            {{ $t('chrome_info.download_button') }}
          </a>
          <button class="btn btn-status-default" @click="closeModal">
            {{ $t('chrome_info.continue_button') }}
          </button>

        </div>
      </div>
    </Modal>
  </div>
</template>
